import React, { FC } from 'react';
import { Box, Container, Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ProjectCard } from 'components/atoms';
import { NewsPostList } from 'services/news/types';

interface RelatedPostsProps {
  listCards: Array<NewsPostList>;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(12, 0, 19),
  },
  divider: {
    width: 100,
    height: 1,
    backgroundColor: theme.palette.primary.main,
    marginTop: theme.spacing(6),
  },
  textBox: {
    textAlign: 'center',
    margin: '0 auto',
    marginBottom: theme.spacing(10),
  },
  title: {
    color: theme.palette.primary.dark,
    fontWeight: 600,
  },
}));

const NewsRelatedPostsSection: FC<RelatedPostsProps> = ({ listCards }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.textBox}>
        <Typography variant="h2" className={classes.title}>
          Related Posts
        </Typography>
        <Box className={classes.divider} margin="0 auto" />
      </Box>
      <Container fixed>
        <Grid container spacing={5}>
          {listCards.map((post, index, array) => (
            <Grid item lg={4} md={index === array.length - 3 ? 12 : 6} sm={12} key={post.link}>
              <ProjectCard
                subtitle={post.publish_at}
                title={post.title}
                text={post.description}
                image={post.image}
                width={1285}
                height={550}
                link={post.link}
                isNewsBlog
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default NewsRelatedPostsSection;
